import React, { useEffect, useState } from 'react';
import { Perfil } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import ComboSimple from '../../../../../shared/components/Combos/Simple';
import { CreateFecha, ToSQL } from '../../../../../shared/utils/fecha';

export const ComboFechas = (props:any) =>{

  let {data, onChange} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    if(data)
    {
      setOptions(getOptions())
    }
  },[data])

  useEffect(()=>{
    if(options && options.length>0){
      onChange && onChange(options[0].value)
    }
  },[options])
  
  const getOptions = () =>{
    return data.map((p:string)=> { return { value: ToSQL(p,"-"), inputDisplay: CreateFecha(p) } })
  }
  
  return (
    <ComboSimple {...props} options={options} name="selectFechas" />
  )

}
export default ComboFechas